import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { FlexGap, Label, Paragraph, Separator, tokens } from '@treams/treams-ui';

import { formatRevealValue } from './formatRevealValue';

type RevealField = {
	label: string;
	value: string;
	type?: graphql.RevealFieldType | null;
};

interface IProps {
	fields: RevealField[];
}

export function RevealFieldList({ fields }: IProps) {
	const { i18n } = useTranslation();

	return (
		<Box>
			{fields.map((field, index) => (
				<Box key={field.label}>
					{index > 0 && <Separator my={2} />}
					<FlexGap
						justifyContent="space-between"
						alignItems="center"
						flexWrap="wrap"
						gap={tokens.gap.inline}
					>
						<Label>{field.label}</Label>
						<Paragraph>{formatRevealValue(field, i18n.language)}</Paragraph>
					</FlexGap>
				</Box>
			))}
		</Box>
	);
}
